import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        padding: "24px",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{textAlign: 'center'}}>Privacy Policy</h1>
      <p>Introduction to the Privacy Policy</p>

      <p>
        This Privacy Policy explains how the Attendance Management Application
        (“App”) collects, uses, stores, and protects user information. By using
        this App, you agree to the practices described in this policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>The App may collect the following information to provide attendance and office login services:</p>

      <ul>
        <li>
          <strong>Personal Information:</strong> Employee name, employee ID,
          mobile number, email address, and department or office details.
        </li>
        <li>
          <strong>Attendance Information:</strong> Punch-in time, punch-out time,
          working hours, and attendance date.
        </li>
        <li>
          <strong>Location Information:</strong> GPS location at the time of
          attendance marking, collected only for verification purposes.
        </li>
        <li>
          <strong>Device Information:</strong> Device model, operating system,
          app version, and basic diagnostic data.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>Your information is used strictly for official and operational purposes, including:</p>

      <ul>
        <li>Recording and managing employee attendance</li>
        <li>Verifying office login authenticity</li>
        <li>Generating attendance reports</li>
        <li>Improving app performance and reliability</li>
        <li>Ensuring security and preventing misuse</li>
      </ul>

      <h2>3. Data Sharing</h2>
      <p>
        We do not sell or rent user data. Information may be shared only with:
      </p>

      <ul>
        <li>Authorized organization administrators</li>
        <li>Secure backend servers used for attendance processing</li>
        <li>Government or legal authorities when required by law</li>
      </ul>

      <h2>4. App Permissions</h2>
      <p>The App may request the following permissions to function correctly:</p>

      <ul>
        <li><strong>Location:</strong> To verify attendance location</li>
        <li><strong>Camera:</strong> For profile or attendance verification (if enabled)</li>
        <li><strong>Storage:</strong> For uploading required documents or images</li>
        <li><strong>Internet:</strong> For secure communication with servers</li>
      </ul>

      <h2>5. Data Security</h2>
      <p>
        We implement reasonable technical and organizational measures to protect
        user data from unauthorized access, alteration, or disclosure. However,
        no digital system can guarantee complete security.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        Attendance and user data is retained according to organizational policy
        and applicable legal requirements. Data may be deleted upon authorized
        request.
      </p>

      <h2>7. User Rights</h2>
      <p>You have the right to:</p>

      <ul>
        <li>Access your attendance records</li>
        <li>Request correction of incorrect information</li>
        <li>Request account deactivation through your administrator</li>
      </ul>

      <h2>8. Children’s Privacy</h2>
      <p>
        This App is intended for official employee use only and is not designed
        for individuals under the age of 18.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted within the App. Continued use of the App indicates acceptance of
        the updated policy.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact:
      </p>

      <p>
        <strong> Company Name:</strong>{" "}
         Softmate Systems LLP<br />
        <strong>Email:</strong>{" "}
        softmate.suport@gmail.com"<br />
         
        
      </p>
    </div>
  );
}
